export default class Button{
    constructor(x, y, endx, endy){
        this.x = x;
        this.y = y;
        this.endx = endx;
        this.endy = endy;
    }
}